import { navigate } from "svelte-routing";
export const loginFromResponse = (response) => {
    localStorage.setItem('credentials', response.data.login);
    navigate("/success", { replace: true });
};
